/* fc-header.js (2026-10-12 speed pass): the header's behaviour, moved out of
   sections/fc-header.liquid so browsers cache it across pages. The root is
   <header id="fc-hd"> (one header per page); per-instance values travel as
   data attributes (data-fc-height). Re-initialises on shopify:section:load
   for the theme editor. The four parts below are the former inline module
   scripts, unchanged apart from the root lookup. */
(function () {
  'use strict';

  /* 1. Global cart-link interceptor: any link to /cart opens the drawer. */
(function(){
    if (window.fcCartIconHooked) return;
    window.fcCartIconHooked = true;

    function isCartLink(el) {
      if (!el) return false;
      if (el.hasAttribute && el.hasAttribute('data-fc-cart-icon')) return true;
      if (el.tagName !== 'A') return false;
      var href = el.getAttribute('href') || '';
      if (!href) return false;
      // Strip query string + hash for cleaner matching
      var path = href.split('?')[0].split('#')[0];
      // Cart page is /cart or /<locale>/cart — NOT /cart/* sub-paths.
      // Examples that MATCH: "/cart", "/en-au/cart", "/de/cart"
      // Examples that DON'T:  "/cart/", "/cart/change", "/cart.js", "/cartiff"
      return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart$/i.test(path);
    }

    document.addEventListener('click', function(e){
      // Let modifier-clicks (cmd, ctrl, middle-button) open in a new tab.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      var link = e.target.closest('a, button, [data-fc-cart-icon]');
      if (!link) return;
      if (!isCartLink(link)) return;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open();
      }
    }, false);
  })();

  /* 2. Shop panel toggle, backdrop, scroll-to-solid.
     Redesign 2026-10-24: the panel's card photos carry data-fc-hd-src /
     data-fc-hd-srcset and get their real src on the first open (or when the
     pointer / focus reaches the Shop button), so a page view that never opens
     the menu fetches none of them. While open, body.fc-hd-open hides the Help
     launcher and the product sticky cart (fc-header.css), and the panel's
     max-height (--fc-hd-pn-max) is the room left below its top edge so the
     sheet scrolls inside itself on phones.
     Phones (two levels, same day): a device row with models
     ([data-fc-hd-go] = the id of its .fc-hd-models__group) opens that group
     as a second screen (panel[data-l2], group.is-active; CSS slides it in),
     [data-fc-hd-back] and Escape go back, every open starts on level 1.
     Photos load only once they are laid out (getClientRects), so phones
     never fetch the hidden desktop cards and a model screen's photos load
     when it opens. */
  function initToggle(root) {
    var btn = root.querySelector('[data-fc-hd-toggle]');
    var backdrop = root.querySelector('[data-fc-hd-backdrop]');
    var panel = root.querySelector('[data-fc-hd-panel]');
    if (!btn) return;

    function loadImages(){
      if (!panel) return;
      panel.querySelectorAll('img[data-fc-hd-src]').forEach(function(img){
        if (!img.getClientRects().length) return; // display:none here (other width, closed model screen)
        var set = img.getAttribute('data-fc-hd-srcset');
        if (set) img.setAttribute('srcset', set);
        img.setAttribute('src', img.getAttribute('data-fc-hd-src'));
        img.removeAttribute('data-fc-hd-src');
        img.removeAttribute('data-fc-hd-srcset');
      });
    }

    function fitPanel(){
      if (!panel) return;
      var top = panel.getBoundingClientRect().top;
      var room = Math.floor(window.innerHeight - Math.max(0, top) - 16);
      if (room > 160) root.style.setProperty('--fc-hd-pn-max', room + 'px');
      loadImages();
    }

    function firstFocusable(scope){
      var els = scope.querySelectorAll('a[href], button');
      for (var i = 0; i < els.length; i++){
        if (!els[i].hidden && els[i].getClientRects().length) return els[i];
      }
      return null;
    }

    function showModels(id, opener){
      var group = id && document.getElementById(id);
      if (!panel || !group) return;
      panel.scrollTop = 0;
      panel.querySelectorAll('.fc-hd-models__group.is-active').forEach(function(g){ g.classList.remove('is-active'); });
      group.classList.add('is-active');
      var box = group.parentNode;
      if (box) box.scrollTop = 0;
      panel.setAttribute('data-l2', id);
      if (opener) opener.setAttribute('aria-expanded', 'true');
      loadImages();
      var back = group.querySelector('[data-fc-hd-back]');
      if (back) back.focus({ preventScroll: true });
    }

    function showDevices(focusOpener){
      if (!panel) return;
      var id = panel.getAttribute('data-l2');
      if (!id) return;
      panel.removeAttribute('data-l2');
      var opener = panel.querySelector('[data-fc-hd-go="' + id + '"]');
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
        if (focusOpener) opener.focus({ preventScroll: true });
      }
    }

    if (panel) panel.addEventListener('click', function(e){
      var go = e.target.closest('[data-fc-hd-go]');
      if (go) { e.preventDefault(); showModels(go.getAttribute('data-fc-hd-go'), go); return; }
      if (e.target.closest('[data-fc-hd-back]')) { e.preventDefault(); showDevices(true); }
    });

    function setOpen(open, restoreFocus){
      root.setAttribute('data-open', open ? 'true' : 'false');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('fc-hd-open', open);
      if (open) {
        showDevices(false);
        fitPanel();
        if (panel) panel.scrollTop = 0;
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', fitPanel);
      } else {
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', fitPanel);
        if (restoreFocus) btn.focus();
      }
    }

    function onKey(e){
      if (e.key !== 'Escape') return;
      if (panel && panel.hasAttribute('data-l2')) showDevices(true);
      else setOpen(false, true);
    }

    btn.addEventListener('click', function(e){
      e.stopPropagation();
      var open = root.getAttribute('data-open') === 'true';
      setOpen(!open);
      // Opened from the keyboard (Enter / Space give a click with detail 0):
      // the panel sits after the logo and icons in the DOM, so move focus to
      // its first link instead of letting Tab wander through the bar first.
      if (!open && e.detail === 0 && panel) {
        var first = firstFocusable(panel);
        if (first) first.focus({ preventScroll: true });
      }
    });
    btn.addEventListener('pointerenter', loadImages);
    btn.addEventListener('focus', loadImages);
    btn.addEventListener('touchstart', loadImages, { passive: true });

    if (backdrop) backdrop.addEventListener('click', function(){ setOpen(false); });

    document.addEventListener('click', function(e){
      if (root.getAttribute('data-open') !== 'true') return;
      if (root.contains(e.target)) return;
      setOpen(false);
    });

    // Scroll-to-solid: once the user scrolls past the hero zone the
    // transparent header becomes solid so text/icons stay readable.
    var threshold = Math.max(40, ((parseInt(root.getAttribute('data-fc-height'), 10) || 96) - 8));
    var ticking = false;
    function syncScroll(){
      ticking = false;
      if (window.scrollY > threshold) root.classList.add('is-scrolled');
      else root.classList.remove('is-scrolled');
    }
    function onScroll(){
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncScroll);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    syncScroll();
  }

  /* 3. Detected-phone shortcut inside the dropdown. */
  function initDetect(root) {
    if (typeof window.fcDetectPhone !== 'function') return;
    var anchor = root.querySelector('[data-fc-hd-detect]');
    if (!anchor) return;
    var nameEl = anchor.querySelector('[data-fc-hd-detect-name]');

    // Redesign 2026-10-24: the panel lists model tiles (data-fc-model = the
    // full menu title, lower case, e.g. "galaxy z fold 7"). The detected name
    // ("Galaxy Z Fold 7") links straight to its tile, which gets an orange
    // ring (.is-yours). Without a tile, match the family keyword against the
    // device cards ("Fold Team" / "Fold-Serie"). Neither: the anchor keeps
    // its Liquid fallback href (routes.collections_url).
    function norm(s){ return (s || '').toLowerCase().replace(/^samsung\s+/, '').replace(/\s+/g, ' ').trim(); }
    function modelChip(name){
      var want = norm(name);
      var chips = root.querySelectorAll('.fc-hd-panel [data-fc-model]');
      for (var i=0; i<chips.length; i++){
        if (norm(chips[i].getAttribute('data-fc-model')) === want) return chips[i];
      }
      return null;
    }
    function smartHref(name){
      var nameLc = name.toLowerCase();
      var keyword = nameLc.indexOf('fold') !== -1 ? 'fold'
                  : nameLc.indexOf('flip') !== -1 ? 'flip'
                  : null;
      if (!keyword) return null;
      var links = root.querySelectorAll('.fc-hd-panel .fc-hd-dev__card[href], .fc-hd-panel .fc-hd-model[href]');
      for (var i=0; i<links.length; i++){
        if ((links[i].textContent || '').toLowerCase().indexOf(keyword) !== -1){
          return links[i].getAttribute('href');
        }
      }
      return null;
    }

    window.fcDetectPhone(function(name){
      if (!name) return;
      nameEl.textContent = name;
      var chip = modelChip(name);
      if (chip) chip.classList.add('is-yours');
      var href = chip ? chip.getAttribute('href') : smartHref(name);
      if (href) anchor.setAttribute('href', href);
      anchor.removeAttribute('hidden');
    });
  }

  /* 4. News bell panel. */
  function initNews(root) {
    /* Dot is permanent by design (2026-07-16, user preference): it renders
     unconditionally in Liquid and is never cleared. This script only
     handles opening/closing the news panel. */
  var wraps = root.querySelectorAll('[data-fc-news]');
  if (!wraps.length) return;
  wraps.forEach(function (wrap) {
    var btn = wrap.querySelector('[data-fc-news-toggle]');
    var panel = wrap.querySelector('.fc-hd-news__panel');
    if (!btn || !panel) return;
    function close() { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    try {
      if (sessionStorage.getItem('fcNewsBellOpened')) btn.classList.add('is-opened');
    } catch (e) {}
    btn.addEventListener('click', function () {
      var opening = panel.hidden;
      panel.hidden = !opening;
      btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        btn.classList.add('is-opened');
        try { sessionStorage.setItem('fcNewsBellOpened', '1'); } catch (e) {}
      }
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !e.target.closest('[data-fc-news]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });
  }

  function init() {
    var root = document.getElementById('fc-hd');
    if (!root || root.getAttribute('data-fc-init') === '1') return;
    root.setAttribute('data-fc-init', '1');
    initToggle(root);
    initDetect(root);
    initNews(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-hd')) init();
  });
})();
